{
  "title": "Carriers",
  "subtitle": "Transport/logistics companies used for dispatch — Loading Task and a Customer's Preferred Carrier both draw from this list.",
  "addCarrier": "New Carrier",
  "edit": "Edit",
  "delete": "Delete",
  "saveCarrier": "Save",
  "discardChanges": "Cancel",
  "table": {
    "code": "Code",
    "name": "Name",
    "status": "Status"
  },
  "form": {
    "code": "Code",
    "name": "Name",
    "status": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "validation": {
      "codeRequired": "Code is required.",
      "nameRequired": "Name is required."
    }
  },
  "deleteCarrier": {
    "message": "Delete this carrier? It will no longer be offered on Loading Task or as a Customer's Preferred Carrier — any past record that already references it is unaffected."
  }
}
